import { createAction } from '@reduxjs/toolkit'

import { ActionTypes } from '../actionTypes'

export const showLoader = createAction(ActionTypes.loader.load.typeName)
export const hideLoader = createAction(ActionTypes.loader.unload.typeName)
